import React from "react";

const TermsOfServiceEnterprise = () => {
  return (
    <div className="bg-black w-full min-h-[calc(100vh-120px)] py-12">
      <div className="text-gray-400 font-secondary px-8 max-w-[900px] mx-auto md:px-6 sm:px-4 text-left">
        <h1 className="font-primary text-[2.8rem] text-center mb-10 text-white font-bold md:text-[2.2rem] sm:text-[1.8rem]">
          Terms of Service – Enterprise
        </h1>

        <section className="mb-10">
          <p className="text-[1.1rem] leading-[1.7] text-gray-500 mb-4 sm:text-[1rem]">
            Updated on 15th October, 2025
          </p>
          <p className="text-[1.1rem] leading-[1.7] text-gray-300 mb-4 sm:text-[1rem]">
            Welcome to FOZZIL Enterprise. These Terms of Service apply to organizations, healthcare providers, and businesses using FOZZIL's enterprise solutions, including T.A.E.L.S, Zypher AI, FOZZIL MEDOS, and our Edge-Server appliances.
          </p>
        </section>
        
        <section className="mb-10 text-left">
          <h2 className="font-primary text-[1.8rem] mb-5 text-white border-b border-gray-800 pb-2 md:text-[1.5rem] sm:text-[1.3rem]">
            Enterprise License & Usage
          </h2>
          <p className="text-[1.1rem] leading-[1.7] text-gray-300 mb-4 sm:text-[1rem]">
            Under an Enterprise Agreement, FOZZIL grants your organization a non-exclusive, non-transferable license to access and use our suite of AI services for your internal business and clinical operations. By using our enterprise features, you agree to comply with our API restrictions, data compliance protocols, and SLA terms outlined in your specific contract.
          </p>
        </section>

        <section className="mb-10 text-center border-t border-gray-800 pt-10">
          <h2 className="font-primary text-[1.8rem] mb-5 text-white md:text-[1.5rem] sm:text-[1.3rem]">
            Contact Us
          </h2>
          <p className="text-[1.1rem] leading-[1.7] text-gray-300 mb-4 sm:text-[1rem]">
            For enterprise onboarding and compliance inquiries, please contact: <br />
            <span className="text-white font-bold">FOZZIL Enterprise Support</span><br />
            <a href="mailto:enterprise@fozzil.in" className="text-blue-400 hover:underline">enterprise@fozzil.in</a>
          </p>
        </section>
      </div>
    </div>
  );
};

export default TermsOfServiceEnterprise;
